import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  flag: false
};

const updateMeetingSlice = createSlice({
  name: 'updateMeeting',
  initialState,
  reducers: {
    setUpdateMeetingFlag: (state, action) => {
      state.flag = action.payload;
    }
  }
});

export default updateMeetingSlice.reducer;
export const { setUpdateMeetingFlag } = updateMeetingSlice.actions;
